import { FileApi } from "generated/apiFiles";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const fetchMemoryItemsInFolder = {
  queryFn: async (id: string) => {
    const authUser: any = getLoggedinUser();

    const api = new FileApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.fileControllerFind(id);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchMemoryItemsInFolder", { ...data }],
};

export const fetchMemoryItemsInFolderForTable = {
  queryFn: async (data: any) => {
    const authUser: any = getLoggedinUser();

    const api = new FileApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.fileControllerFindItemsInFolder(data);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchMemoryItemsInFolderForTable", { ...data }],
};
